import { put, call, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import { toast } from "react-toastify";
import {
  ADD_VENDOR,
  EDIT_VENDOR,
  GET_VENDORS,
  GET_VENDOR_BY_ID,
  REMOVE_VENDOR,
} from "../../services/ApiCalls";

function* getVendorsSaga({ payload, callBack }) {
  try {
    const response = yield call(GET_VENDORS, payload);
    if (response.data.status == "success") {
      yield put(ACTION.getVendorsSuccess(response?.data));
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.getVendorsFail(error));
    }
  } catch (error) {
    yield put(ACTION.getVendorsFail(error));
  }
}

function* removeVendorsSaga({ payload, callBack }) {
  try {
    const response = yield call(REMOVE_VENDOR, payload);
    if (response.data.status === "success") {
      yield put(ACTION.removeVendorSuccess());
      toast.success(response?.data?.message);
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.removeVendorFail());
    }
  } catch (error) {
    yield put(ACTION.removeVendorFail());
  }
}
function* addVendorsSaga({ payload, callBack }) {
  try {
    const response = yield call(ADD_VENDOR, payload);
    if (response.data.status === "success") {
      toast.success(response?.data?.message);
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
    }
  } catch (error) {
    toast.error(error);
  }
}

function* editVendorsSaga({ payload, callBack }) {
  try {
    const response = yield call(EDIT_VENDOR, payload);
    if (response.data.status === "success") {
      toast.success(response?.data?.message);
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      callBack && callBack();
    }
  } catch (error) {
    toast.error(error);
  }
}

function* getVendorDataByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(GET_VENDOR_BY_ID, payload);
    if (response.data.status === "success") {
      yield put(ACTION.getVendorsByIdSuccess(response?.data?.data));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (error) {
    toast.error(error);
  }
}

function* vendorSaga() {
  yield takeEvery(CONST.GET_VENDORS, getVendorsSaga);
  yield takeEvery(CONST.REMOVE_VENDOR, removeVendorsSaga);
  yield takeEvery(CONST.ADD_VENDOR, addVendorsSaga);
  yield takeEvery(CONST.GET_VENDORS_BY_ID, getVendorDataByIdSaga);
  yield takeEvery(CONST.EDIT_VENDOR, editVendorsSaga);
}

export default vendorSaga;
